const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  changeKits ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/parcel-ptyt/change-kits', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
